const policyItems = [].slice.call(document.getElementsByClassName('policies-row pointer')) as Array<HTMLInputElement>;
const viewMore:HTMLElement = document.getElementById('policiesViewMore');
const initialNumber:HTMLInputElement = document.getElementById('InitialNumber') as HTMLInputElement;
const viewAllLabel:HTMLInputElement = document.getElementById('CurrentBlock_ViewAllLabel') as HTMLInputElement;
const viewLessLabel:HTMLInputElement = document.getElementById('CurrentBlock_ViewLessLabel') as HTMLInputElement;

if (viewMore && policyItems)
{
    if(policyItems.length <= parseInt(initialNumber.value)) {
        viewMore.style.display= 'none';
    }
    viewMore.addEventListener('click',
    () => {
        if (viewMore.textContent.toLowerCase() === viewAllLabel.value.toLowerCase())
        {
            policyItems.forEach((policy) => {
                if (policy.classList.contains('hide'))
                {
                    policy.classList.remove('hide');
                }
             });
             viewMore.textContent = viewLessLabel.value;
        }
        else
        {
            policyItems.forEach((policy, index) => {
                if (index >= parseInt(initialNumber.value))
                {
                    policy.classList.add('hide');
                }
             });
             viewMore.textContent = viewAllLabel.value; 
        }
    });
}